module.exports = __webpack_public_path__ + "img/manage-account.287ca97f.png";